import { useQuery } from "react-query";
import { axiosInstance } from "../../config/axios";
import { QueryKeys } from "../queryKeys";

export interface IGetResponseCodeRequest {
  page?: number;
  size?: number;
  orderByDesc?: boolean;
  orderBy?: string;
  status?: string;
  filters?: {
    field: string;
    values: string[];
    valueType: number;
    operationType: number;
  }[];
}

export interface IResponseCode {
  id: number;
  errorCode: string;
  errorSource: string;
  errorCodeDesc: string;
  errorDetail: string;
  integrationCode: string;
  internalErrorCode: string;
  internalErrorCodeDesc: string;
  bankName: string;
}

export interface IGetResponseCodeResponse {
  currentPage: number;
  pageSize: number;
  totalPages: number;
  totalItems: number;
  orderBy: string;
  orderByDesc: boolean;
  result: IResponseCode[];
}

async function getResponseCodes(
  params: IGetResponseCodeRequest
): Promise<IGetResponseCodeResponse> {

  params.filters?.push({
    field: "status",
    values: ["ACTIVE"],
    valueType: 1,
    operationType: 6,
  });

  const { data } = await axiosInstance.post("/ResponseCode/GetResponseCodes", params);
  return data.data;
}

export function useGetResponseCodes(params: IGetResponseCodeRequest) {
  return useQuery(
    [QueryKeys.responseCodes, params],
    () => getResponseCodes(params),
    {
      enabled: false,
    }
  );
}
